var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92229 38.9385L36.3509 38.9385C37.9288 38.9385 39.208 37.6593 39.208 36.0813L39.208 4.65276C39.208 3.07481 37.9288 1.79562 36.3509 1.79562L4.92229 1.79562C3.34434 1.79562 2.06515 3.07481 2.06515 4.65276L2.06515 36.0813C2.06515 37.6593 3.34434 38.9385 4.92229 38.9385Z",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20801 8.93848H14.9223",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20801 16.082H22.0651",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4937 16.082L24.9223 30.3677L14.9223 24.6535L9.20801 33.2249",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurBenefit1);
export default __webpack_public_path__ + "static/media/icon-our-benefit-1.15cbcbbca73663fdb168fa76d6bb63f5.svg";
export { ForwardRef as ReactComponent };